<template>
	<li :class="className">
		<router-link :exact="exact" :to="to" tag="a" :class="aClassName" active-class="active">
			<slot />
		</router-link>
		<div class="dropdown-menu" v-if="dropdown">
			<slot name="dropdown" />
		</div>
	</li>
</template>

<script>
export default {
	name: 'MenuItem',
	props: {
		to: {
			required: true,
		},
		tag: {
			type: String,
			default: 'li',
			required: false,
		},
		exact: {
			type: Boolean,
			default: true,
			required: false,
		},
		className: {
			type: String,
			default: 'nav-item',
			required: false,
		},
		aClassName: {
			type: String,
			default: 'nav-link',
			required: false,
		},
		dropdown: {
			type: String,
			default: '',
			required: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		aTagClassName() {
			let classes = this.aClassName;

			if (this.active) {
				classes += ' active';
			}

			return classes;
		},
		current_to() {
			return this.$router.history.current.path;
		},
		active() {
			if (this.$router.history.current.path === this.to) {
				return true;
			} else {
				return false;
			}
		},
	},
};
</script>
